import { render, staticRenderFns } from "./OppositionForm.vue?vue&type=template&id=daaa9f14&"
import script from "./OppositionForm.vue?vue&type=script&lang=ts&"
export * from "./OppositionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daaa9f14')) {
      api.createRecord('daaa9f14', component.options)
    } else {
      api.reload('daaa9f14', component.options)
    }
    module.hot.accept("./OppositionForm.vue?vue&type=template&id=daaa9f14&", function () {
      api.rerender('daaa9f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaignFactory/Test/OppositionForm.vue"
export default component.exports